import { call } from 'redux-saga/effects'
import { action as apiAction } from 'api/Api'

export default function * requestAddUserToLayout (action) {
  const { layoutId, userId, permissionLevel } = action.payload

  try {
    yield call(apiAction, 'AddUserToHomeLayout', {
      layoutId,
      userId,
      level: permissionLevel
    })
  } catch (error) {
    if (error.code !== 300) {
      throw error
    }
  }
}
